/**
 * Data processor to transform leaveTypes (id/name) to options format (value/label) for SelectField
 * 
 * This processor intercepts responses from /odoo/hr.leave.type/search_read and transforms
 * the array of objects with id/name properties into an array with value/label properties
 * that SelectField expects.
 */
export const leaveTypesToOptionsProcessor = ({ requestContext, responseContext, dataToProcess, originalDataToProcess }) => {
    // Only process hr.leave.type responses
    if (!requestContext.url.includes('/odoo/hr.leave.type/search_read')) {
        return dataToProcess; // Return unchanged
    }
    
    // Check response status
    if (responseContext.status >= 400) {
        return dataToProcess; // Return unchanged
    }
    
    // Ensure data is an array
    if (!Array.isArray(dataToProcess)) {
        return dataToProcess; // Return unchanged
    }
    
    // Transform leaveTypes array to options format for SelectField
    const processedData = dataToProcess.map(item => ({
        value: item.id?.toString() || '',
        label: item.name || '',
    }));
    
    return processedData;
};
